const videoPlayer = videojs('GundryMDVSL');
const isMobileDeviceWithIpad = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(navigator.userAgent);
const mobileVideoID = $('video-js').attr('data-video-id-mobile');

//- Handle cookies for VSL Play button
if (!$.cookie('DRC-VSL-Recode')) {
  videoPlayer.ready(function () {
    this.on('timeupdate', function () {
      if (this.currentTime() >= (60 * timePlaying) || this.currentTime() == this.duration()) {
        $("#videoCTAWrap").removeClass('hide');
      }
    })
  });

  $.cookie("DRC-VSL-Recode", 1, { expires: 7 });
}
else {
  $("#videoCTAWrap").removeClass('hide');
}

//- Different VSL on mobile and desktop
const changeVslOnMobile = (play) => {
  if (typeof mobileVideoID !== 'undefined' && mobileVideoID != '') {
    let isMobileDevice = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobileDevice) {
      const myPlayer = videojs.getPlayer($('video-js').attr('id'))
      if (window.innerHeight > window.innerWidth) {
        myPlayer.catalog.getVideo(mobileVideoID, function (error, video) {
          myPlayer.catalog.load(video);
          play ? myPlayer.play() : null;
        });
      }
    }
  };
}

//- Full screen VSL
const handleFullScreenInline = () => {
  let startScrollTop,
    endScrollTop;

  $(".video").on("touchstart", function () {
    startScrollTop = $(window).scrollTop();
  });

  $(".video").on('touchend', function () {
    endScrollTop = $(window).scrollTop();
  });

  $(".video").on('click touchend', function () {
    if (startScrollTop === endScrollTop) {
      window.scrollTo(0, 0);

      if ($('body').hasClass('fullScreenVsl')) {
        videoPlayer.pause();
        $('.vjs-big-play-button').show();
        $('body').removeClass('fullScreenVsl');
      } else {
        videoPlayer.play();
        $('.vjs-big-play-button').hide();
        $('body').addClass('fullScreenVsl');
      };
    }
  });

  $(".video").one('click touchend', function () {
    changeVslOnMobile(true)
  })
}

let isPlaying = false;
const playPauseVideo = () => {
  $(".video").on('click touchend', function () {
    if (isPlaying) {
      videoPlayer.pause();
    } else {
      videoPlayer.play(); 
    }
    isPlaying = !isPlaying;
  });
}

if (typeof isFullScreenInlineDesktop !== 'undefined' && isFullScreenInlineDesktop == true && !isMobileDeviceWithIpad) {
  handleFullScreenInline()
}

if (typeof isFullScreenInlineMobile !== 'undefined' && isFullScreenInlineMobile == true && isMobileDeviceWithIpad) {
  handleFullScreenInline()
} else if (isMobileDeviceWithIpad) {
  playPauseVideo()
}

changeVslOnMobile();